import {FC} from 'react';
import {CloseHeader, Header} from 'features/registration';
import type {RegistrationDerived} from './useRegistrationDerived';
import styles from './RegistrationWizard.module.css';

type Props = {
	useCloseHeader: boolean;
	headerProgress: RegistrationDerived['headerProgress'];
	isEditingFromIdentityReview: boolean;
	onBack: () => void;
	onClose: () => void;
};

/** Шапка визарда: пагинация регистрации либо только крестик. */
export const RegistrationWizardHeader: FC<Props> = ({
	useCloseHeader,
	headerProgress,
	isEditingFromIdentityReview,
	onBack,
	onClose,
}) => {
	return (
		<div className={styles.headerBlock}>
			{useCloseHeader ? (
				<CloseHeader onClose={onClose} />
			) : (
				<Header
					currentStep={headerProgress?.currentStep ?? 0}
					totalSteps={headerProgress?.totalSteps ?? 4}
					onBack={(headerProgress?.currentStep ?? 0) === 0 ? undefined : onBack}
					onClose={onClose}
					showProgress={
						!isEditingFromIdentityReview &&
						Boolean(headerProgress) &&
						(headerProgress?.totalSteps ?? 0) > 1
					}
				/>
			)}
		</div>
	);
};
